import { BACKGROUND_TASK_STATES } from "@api/progress-api/progress-api-constants";
import { SphereNotificationPopover } from "@components/common/sphere-notification-popover";
import { BaseBackgroundTaskProps } from "@custom-types/sdb-background-tasks-types";
import { Box } from "@mui/material";
import { blue, green, neutral, red, yellow } from "@flat-ui";
import { DASH } from "@utils/ui-utils";

/** Renders the status of the background tasks */
export function BackgroundTaskStatus({
  task,
}: BaseBackgroundTaskProps): JSX.Element {
  let fontColor: string;
  const status = task.state ?? DASH;
  const message = task.message;

  switch (status) {
    case BACKGROUND_TASK_STATES.Created:
    case BACKGROUND_TASK_STATES.Scheduled:
      fontColor = neutral[800];
      break;

    case BACKGROUND_TASK_STATES.Started:
      fontColor = blue[600];
      break;

    case BACKGROUND_TASK_STATES.Succeeded:
      fontColor = green[700];
      break;

    case BACKGROUND_TASK_STATES.Aborted:
      fontColor = yellow[500];
      break;

    case BACKGROUND_TASK_STATES.Failed:
      fontColor = red[500];
      break;

    default:
      fontColor = neutral[800];
  }

  return (
    <Box component="div" display="flex" alignItems="center">
      <Box
        component="div"
        sx={{
          color: fontColor,
          fontWeight: "600",
        }}
      >
        {status}
      </Box>
      {message && (
        <SphereNotificationPopover
          message={message}
          sx={{
            marginLeft: "10px",
          }}
        />
      )}
    </Box>
  );
}
